import * as React from "react"
import { Skeleton } from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { useToast, useUserApp } from "@hooks"
import { isLoadingCommonFilters } from "@signals"
import { useStockShareSearch } from "./@hooks"
import { diffColumn, pricesColumn, retailerColumn, sellerColumn, shareColumn, skuColumn, stockStatusColumn, numVariantsColumn } from "./columns"
import { useStockShareRoleConfig } from "../@hooks"


const HEIGHT = 500

export default function StockShareTable() {

	const { stockShareData } = useStockShareSearch()
	const { showToast } = useToast()
	const { isMarketplacesUser, isRetailerUser, userUseRRSP, urlApiExcel } = useStockShareRoleConfig()
	const { userGroupByProductID } = useUserApp()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!stockShareData?.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title="Stock Share" />}
		data={stockShareData}
		columns={[
			...retailerColumn(),
			...skuColumn(),
			...isMarketplacesUser ? [...sellerColumn()] : [],
			stockStatusColumn('prevStock', 'Previous Stock Status', 'prevStockColor', false),
			stockStatusColumn('stock', 'Stock Status', 'stockColor', true),
			shareColumn('outOfStockShare', '% of Out of Stock'),
			shareColumn('delistedShare', '% of Delisted'),
			shareColumn('notListedShare', '% Not Listed'),
			shareColumn('stockShare', '% In Stock'),
			...!userGroupByProductID ? [numVariantsColumn()] : [],
			...!isMarketplacesUser ? [pricesColumn('price', 'Price')] : [],
			...!isMarketplacesUser && userUseRRSP ? [pricesColumn('myPrice', isRetailerUser ? 'My Price' : 'RRSP')] : [],
			...!isMarketplacesUser && userUseRRSP ? [diffColumn(isRetailerUser ? 'Diff vs My Price' : 'Diff vs RRSP')] : []
		]}
		options={{
			onDownload: () => showToast.promiseExcel(urlApiExcel),
			enhancedSetRowProps: () => ({ sx: {
				"&:has(.is-open)": {backgroundColor: "primary.light"}
			} })
		}}
	/>
}